import { useDashboardRealtime } from '../context/RealtimeContext';

export function useAgentSocket(companyId) {
  if (!companyId) {
    console.warn('[useAgentSocket] No companyId provided');
  }
  return useDashboardRealtime();
}

export default useAgentSocket;
